/* SÁRO cart — replaces Unicorn Cart. Works on top of the Impulse theme's own cart drawer:
   - free shipping progress bar with lock / tick reward (Australia only)
   - free gift marker on the same bar: the gift adds itself at the gift amount and drops off below it (Australia only)
     "No thanks" on the gift line declines it for this order; "Add my free gift" brings it back
   - "You may also like" (Shopify's own product recommendations) with a size pop-up
   - shipping protection: main checkout button includes it, the link underneath checks out without it
   - bin (remove) button and the "Add order note" toggle
   Low stock alerts and "You save" tags are rendered in Liquid (snippets/cart-item.liquid). */
(function () {
  'use strict';
  if (window.SVCartLoaded) return;
  window.SVCartLoaded = true;

  var XSELL_COUNT = 3;

  function money(cents) {
    try { return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function short(cents) { return money(cents).replace(/\.00$/, ''); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function post(url, data) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }
  function rebuild() { document.dispatchEvent(new CustomEvent('cart:build')); }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function init() {
    var form = document.querySelector('[data-sv-cart]');
    if (!form) return;
    var q = function (s) { return form.querySelector(s); };
    var products = q('[data-products]');
    var threshold = parseInt(form.getAttribute('data-sv-free-ship') || '0', 10);
    var giftAt = parseInt(form.getAttribute('data-sv-gift-at') || '0', 10);
    var protectVariant = form.getAttribute('data-sv-protect-variant');
    var protectPrice = parseInt(form.getAttribute('data-sv-protect-price') || '0', 10);
    var ship = q('[data-sv-ship]'), shipMsg = q('[data-sv-ship-msg]'), shipFill = q('[data-sv-ship-fill]');
    var xsell = q('[data-sv-xsell]'), xsellList = q('[data-sv-xsell-list]');
    var total = q('[data-sv-total]'), totalAlt = q('[data-sv-total-alt]');
    var pop = q('[data-sv-pop]'), popCard = q('[data-sv-pop-card]');
    var state = { goods: 0, protectQty: 0, giftQty: 0, giftKey: '', giftVariant: '', giftProduct: '', first: '', ids: [] };
    var xsellData = {};
    var lastXsellFor = null;

    function readState() {
      var items = products && products.querySelector('.cart__items');
      if (!items) return false;
      state.goods = parseInt(items.getAttribute('data-sv-goods-total') || '0', 10);
      state.protectQty = parseInt(items.getAttribute('data-sv-protect-qty') || '0', 10);
      state.giftQty = parseInt(items.getAttribute('data-sv-gift-qty') || '0', 10);
      state.giftKey = items.getAttribute('data-sv-gift-key') || '';
      state.giftVariant = items.getAttribute('data-sv-gift-variant') || ''; // empty when the customer said "No thanks"
      state.giftProduct = items.getAttribute('data-sv-gift-product') || '';
      state.first = items.getAttribute('data-sv-first-product') || '';
      state.ids = (items.getAttribute('data-sv-product-ids') || '').split(',').filter(Boolean);
      return true;
    }

    function update() {
      if (!readState()) return;
      renderShipping();
      renderTotals();
      renderXsell();
      if (syncGift()) return; // the cart re-renders once the gift is sorted; carry on then
      // Protection on its own is not an order: tidy it away
      if (state.protectQty > 0 && state.ids.length === 0) setProtection(false).then(rebuild);
    }

    // ---- free gift: add it at the gift amount, take it off below ----
    var giftBusy = false, giftFailed = false;
    function syncGift() {
      if (giftBusy) return true;
      var want = (giftAt > 0 && state.giftVariant && !giftFailed && state.ids.length > 0 && state.goods >= giftAt) ? 1 : 0;
      if (state.giftQty === want) return false;
      var req;
      if (state.giftQty === 0) req = post('/cart/add.js', { items: [{ id: parseInt(state.giftVariant, 10), quantity: 1 }] });
      else if (state.giftKey) req = post('/cart/change.js', { id: state.giftKey, quantity: want });
      else return false;
      giftBusy = true;
      req.then(function (res) { if (want && res && res.status) giftFailed = true; })
        .catch(function () { if (want) giftFailed = true; })
        .then(function () {
          rebuild();
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () { giftBusy = false; update(); }, 1200);
        });
      return true;
    }

    // "No thanks" / "Add my free gift" — remembered on the cart (attribute _sv_gift_declined)
    form.addEventListener('click', function (e) {
      var no = e.target.closest('[data-sv-gift-decline]');
      var yes = e.target.closest('[data-sv-gift-undo]');
      if (!no && !yes) return;
      e.preventDefault();
      (no || yes).disabled = true;
      var line = no && no.closest('.cart__item');
      if (line) line.classList.add('is-removing');
      giftBusy = true;
      giftFailed = false;
      var p = post('/cart/update.js', { attributes: { _sv_gift_declined: no ? '1' : '' } });
      if (no && state.giftKey) p = p.then(function () { return post('/cart/change.js', { id: state.giftKey, quantity: 0 }); });
      p.catch(function () {}).then(function () {
        giftBusy = false;
        rebuild();
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
    });

    // ---- totals on the checkout buttons ----
    function renderTotals() {
      if (total) total.textContent = money(state.goods + (protectVariant ? protectPrice : 0));
      if (totalAlt) totalAlt.textContent = money(state.goods);
    }

    // ---- free shipping bar (Australia only) ----
    function renderShipping() {
      if (!ship || !threshold) return;
      if (state.ids.length === 0) { ship.hidden = true; return; }
      ship.hidden = false;
      var remaining = threshold - state.goods;
      var giftLeft = giftAt > 0 ? giftAt - state.goods : 0;
      shipFill.style.width = Math.max(0, Math.min(100, state.goods / threshold * 100)) + '%';
      ship.classList.toggle('is-done', remaining <= 0);
      ship.classList.toggle('is-gift', giftAt > 0 && giftLeft <= 0);
      var msg;
      if (giftAt > 0 && giftLeft > 0) msg = 'Add ' + short(giftLeft) + ' to receive a free gift';
      else if (remaining > 0) msg = (giftAt > 0 ? 'Free gift unlocked! ' : '') + 'Add ' + short(remaining) + ' to receive complimentary shipping';
      else msg = giftAt > 0 ? 'You’ve unlocked a free gift and complimentary shipping' : 'You’ve unlocked complimentary shipping';
      shipMsg.innerHTML = '<strong>' + msg + '</strong>';
    }

    // ---- you may also like ----
    function renderXsell() {
      if (!xsell) return;
      if (!state.first) { xsell.hidden = true; lastXsellFor = null; return; }
      var key = state.first + '|' + state.ids.join(',');
      if (key === lastXsellFor) return;
      lastXsellFor = key;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'recommendations/products.json?product_id=' + state.first + '&limit=10&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var inCart = state.ids.map(String);
          var list = (data.products || []).filter(function (p) {
            return p.available && inCart.indexOf(String(p.id)) === -1 && p.handle !== 'shipping-protection' && String(p.id) !== state.giftProduct;
          }).slice(0, XSELL_COUNT);
          if (!list.length) { xsell.hidden = true; return; }
          list.forEach(function (p) { xsellData[p.id] = p; });
          xsellList.innerHTML = list.map(cardHtml).join('');
          xsell.hidden = false;
        }).catch(function () { xsell.hidden = true; });
    }

    function priceHtml(p) {
      return (p.compare_at_price && p.compare_at_price > p.price ? '<s class="sv-xsell__was">' + money(p.compare_at_price) + '</s>' : '') +
        '<span class="sv-xsell__now">' + money(p.price) + '</span>';
    }
    function cardHtml(p) {
      return '<div class="sv-xsell__item">' +
        '<a href="' + esc(p.url) + '" class="sv-xsell__img">' + (p.featured_image ? '<img src="' + esc(sized(p.featured_image, 300)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
        '<a href="' + esc(p.url) + '" class="sv-xsell__name">' + esc(p.title) + '</a>' +
        '<div class="sv-xsell__price">' + priceHtml(p) + '</div>' +
        '<button type="button" class="sv-btn sv-btn--primary sv-btn--small" data-sv-xsell-add="' + p.id + '">+ Add</button>' +
        '</div>';
    }

    function addVariant(id, btn) {
      if (btn) { btn.disabled = true; btn.setAttribute('data-label', btn.textContent); btn.textContent = 'Adding…'; }
      return post('/cart/add.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] }).then(function (res) {
        if (res && res.status) throw new Error(res.description || 'Could not add');
        closePop();
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res } }));
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Sold out'; }
      });
    }

    // Size pop-up (like Unicorn's variant pop-up)
    function openVariantPop(p) {
      var avail = p.variants.filter(function (v) { return v.available; });
      popCard.innerHTML =
        (p.featured_image ? '<img class="sv-pop__img" src="' + esc(sized(p.featured_image, 300)) + '" alt="">' : '') +
        '<p class="sv-pop__name">' + esc(p.title) + '</p>' +
        '<div class="sv-pop__price">' + priceHtml(p) + '</div>' +
        '<div class="sv-pop__sizes">' + p.variants.map(function (v) {
          return '<button type="button" class="sv-pop__size" data-sv-size="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.public_title || v.title) + '</button>';
        }).join('') + '</div>' +
        '<button type="button" class="sv-btn sv-btn--primary" data-sv-pop-add disabled>Add to cart</button>' +
        '<button type="button" class="sv-btn sv-btn--secondary" data-sv-pop-close>Back to products</button>';
      if (avail.length === 1) {
        var only = popCard.querySelector('[data-sv-size="' + avail[0].id + '"]');
        if (only) only.click();
      }
      pop.hidden = false;
    }
    function openTermsPop() {
      var tpl = q('[data-sv-terms-tpl]');
      if (!tpl) return;
      popCard.innerHTML = tpl.innerHTML;
      pop.hidden = false;
    }
    function closePop() { if (pop) { pop.hidden = true; popCard.innerHTML = ''; } }

    if (pop) {
      pop.addEventListener('click', function (e) {
        if (e.target === pop || e.target.closest('[data-sv-pop-close]')) { closePop(); return; }
        var size = e.target.closest('[data-sv-size]');
        if (size) {
          popCard.querySelectorAll('[data-sv-size]').forEach(function (b) { b.classList.toggle('is-selected', b === size); });
          var addBtn = popCard.querySelector('[data-sv-pop-add]');
          addBtn.disabled = false;
          addBtn.setAttribute('data-variant', size.getAttribute('data-sv-size'));
          return;
        }
        var add = e.target.closest('[data-sv-pop-add]');
        if (add && add.getAttribute('data-variant')) addVariant(add.getAttribute('data-variant'), add);
      });
    }

    if (xsellList) {
      xsellList.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-sv-xsell-add]');
        if (!btn) return;
        var p = xsellData[btn.getAttribute('data-sv-xsell-add')];
        if (!p) return;
        if (p.variants.length === 1) addVariant(p.variants[0].id, btn);
        else openVariantPop(p);
      });
    }

    // ---- bin button ----
    form.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-sv-remove]');
      if (!rm) return;
      e.preventDefault();
      var line = rm.closest('.cart__item');
      if (line) line.classList.add('is-removing');
      post('/cart/change.js', { id: rm.getAttribute('data-sv-remove'), quantity: 0 }).then(function (cart) {
        rebuild();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      });
    });

    // ---- order note toggle ----
    var note = q('[data-sv-note]');
    if (note) {
      q('[data-sv-note-toggle]').addEventListener('click', function () {
        var open = !note.classList.contains('is-open');
        note.classList.toggle('is-open', open);
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var t = note.querySelector('textarea'); if (t) t.focus(); }
      });
    }

    // ---- shipping protection ----
    var more = q('[data-sv-protect-more]');
    if (more) more.addEventListener('click', function (e) { e.preventDefault(); openTermsPop(); });

    function setProtection(on) {
      if (!protectVariant) return Promise.resolve();
      if (on && state.protectQty === 1) return Promise.resolve();
      if (!on && state.protectQty === 0) return Promise.resolve();
      var p = on && state.protectQty === 0
        ? post('/cart/add.js', { items: [{ id: parseInt(protectVariant, 10), quantity: 1 }] })
        : post('/cart/update.js', { updates: (function () { var u = {}; u[protectVariant] = on ? 1 : 0; return u; })() });
      return p.then(function () { state.protectQty = on ? 1 : 0; });
    }

    // Main button = with protection, link underneath = without. Sort the cart out, then go to checkout.
    var going = false;
    form.addEventListener('submit', function (e) {
      if (going || !protectVariant) return;
      var submitter = e.submitter || document.activeElement;
      if (!submitter || submitter.name !== 'checkout') return;
      var want = !submitter.hasAttribute('data-sv-no-protect') && state.ids.length > 0;
      if ((want && state.protectQty === 1) || (!want && state.protectQty === 0)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      going = true;
      submitter.classList.add('btn--loading');
      setProtection(want).catch(function () {}).then(function () {
        var h = document.createElement('input');
        h.type = 'hidden'; h.name = 'checkout'; h.value = '1';
        form.appendChild(h);
        HTMLFormElement.prototype.submit.call(form);
        setTimeout(function () {
          going = false; submitter.classList.remove('btn--loading');
          if (h.parentNode) h.parentNode.removeChild(h);
        }, 4000);
      });
    }, true);
    window.addEventListener('pageshow', function () { going = false; });

    // ---- keep in sync whenever the theme re-renders the cart ----
    if (products) {
      new MutationObserver(function () { clearTimeout(products._svT); products._svT = setTimeout(update, 50); })
        .observe(products, { childList: true });
    }
    document.addEventListener('cart:updated', function () { setTimeout(update, 400); });
    document.addEventListener('cart:close', closePop);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
